import styled from 'styled-components';

import { Typography } from '../Typography';

import { ButtonIconBackground } from '../../inputs/buttons/ButtonIconBackground';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.xxxs}rem;
`;

export const Label = styled(Typography)``;

export const DataContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.m}rem;
  width: 100%;
  background-color: ${({ theme }) =>
    theme.colors.backgroundLila}; /* CAMBIO: Color azul O.T. ROIS */
  border-radius: 0.5rem;
  padding: 1.5rem 3rem 3rem 3rem;
`;

export const RowContainer = styled.div``;

export const Title = styled(Typography)`
  border-bottom: solid 0.1rem ${({ theme }) => theme.colors.garnet as string};
  padding-bottom: ${({ theme }) => theme.spaces.xxs}rem;
`;

export const Explore = styled(Typography)`
  border-bottom: solid 0.1rem ${({ theme }) => theme.colors.greyLight as string};
  padding-bottom: ${({ theme }) => theme.spaces.xxs}rem;
  display: flex;
  cursor: pointer;
`;

export const DataText = styled(Typography)`
  padding-top: ${({ theme }) => theme.spaces.xxs}rem;
`;
export const ContainerButton = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: -5rem;
  z-index: 1;
`;
export const RemoveButton = styled(ButtonIconBackground)`
  width: 3.5rem;
  height: 3.5rem;
`;
